import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { exportPayments, fetchPaymentTransactions } from "../../api/PaymentAPIs";

export default function PaymentsTransactionsPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [provider, setProvider] = useState("");
  const [method, setMethod] = useState("");
  const [orderId, setOrderId] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const params = {
    page,
    pageSize: 25,
    search,
    status,
    provider,
    method,
    orderId,
    transactionId,
    from: from ? new Date(from).toISOString() : "",
    to: to ? new Date(new Date(to).getTime() + 86400000).toISOString() : "",
  };
  const { data, isLoading, error } = useQuery({
    queryKey: ["paymentTransactions", params],
    queryFn: () => fetchPaymentTransactions(params),
  });
  const totalPages = Math.max(1, Math.ceil((data?.total || 0) / (data?.pageSize || 25)));

  return (
    <div className="space-y-4">
      <div className="bg-white border border-slate-200 rounded-2xl p-4 grid md:grid-cols-4 gap-3">
        <input value={search} onChange={(e) => { setPage(1); setSearch(e.target.value); }} placeholder="بحث برقم الطلب أو الدفع أو العملية" className="border rounded-lg px-3 py-2 md:col-span-2" />
        <input value={orderId} onChange={(e) => { setPage(1); setOrderId(e.target.value); }} placeholder="رقم الطلب" className="border rounded-lg px-3 py-2" />
        <input value={transactionId} onChange={(e) => { setPage(1); setTransactionId(e.target.value); }} placeholder="رقم عملية Kashier" className="border rounded-lg px-3 py-2" />
        <select value={status} onChange={(e) => { setPage(1); setStatus(e.target.value); }} className="border rounded-lg px-3 py-2">
          <option value="">الحالة</option>
          <option value="Paid">مدفوع</option>
          <option value="Pending">قيد الانتظار</option>
          <option value="Failed">فشل</option>
          <option value="Refunded">مسترد</option>
        </select>
        <select value={provider} onChange={(e) => { setPage(1); setProvider(e.target.value); }} className="border rounded-lg px-3 py-2">
          <option value="">المزود</option>
          <option value="Kashier">Kashier</option>
        </select>
        <select value={method} onChange={(e) => { setPage(1); setMethod(e.target.value); }} className="border rounded-lg px-3 py-2">
          <option value="">الطريقة</option>
          <option value="card">بطاقة</option>
          <option value="wallet">محفظة</option>
        </select>
        <input type="date" value={from} onChange={(e) => { setPage(1); setFrom(e.target.value); }} className="border rounded-lg px-3 py-2" />
        <input type="date" value={to} onChange={(e) => { setPage(1); setTo(e.target.value); }} className="border rounded-lg px-3 py-2" />
        <button type="button" onClick={() => exportPayments(params)} className="rounded-lg bg-slate-800 text-white px-3 py-2">تصدير</button>
      </div>
      {isLoading && <p>جاري التحميل...</p>}
      {error && <p className="text-red-600">{error.message}</p>}
      <div className="bg-white border border-slate-200 rounded-2xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr>
              {["الدفع", "الطلب", "المبلغ", "العملة", "المزود", "الطريقة", "الحالة", "عملية Kashier", "الإنشاء", "الدفع"].map((heading) => (
                <th key={heading} className="p-3 text-right">{heading}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(data?.items || []).map((item) => (
              <tr key={item.paymentId} className="border-t cursor-pointer hover:bg-slate-50" onClick={() => navigate(`/payments/${item.paymentId}`)}>
                <td className="p-3">{item.paymentId}</td>
                <td className="p-3">{item.orderId}</td>
                <td className="p-3">{item.amount}</td>
                <td className="p-3">{item.currency}</td>
                <td className="p-3">{item.provider}</td>
                <td className="p-3">{item.paymentMethod || item.requestedMethods || "—"}</td>
                <td className="p-3">{item.status}</td>
                <td className="p-3">{item.transactionId || "—"}</td>
                <td className="p-3">{item.createdAt ? new Date(item.createdAt).toLocaleString() : "—"}</td>
                <td className="p-3">{item.paidAt ? new Date(item.paidAt).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!isLoading && (data?.items || []).length === 0 && <p className="p-4 text-slate-500">لا توجد معاملات.</p>}
      </div>
      <div className="flex items-center gap-3">
        <button type="button" disabled={page <= 1} onClick={() => setPage((value) => value - 1)} className="px-3 py-2 border rounded-lg disabled:opacity-40">السابق</button>
        <span>{page} / {totalPages}</span>
        <button type="button" disabled={page >= totalPages} onClick={() => setPage((value) => value + 1)} className="px-3 py-2 border rounded-lg disabled:opacity-40">التالي</button>
      </div>
    </div>
  );
}
